// Mock data for GWF Webinar landing clone. All form submissions are stored in localStorage (frontend-only mock).

export const EVENT = {
  dateLabel: "SEPTEMBER 15TH, 2026 AT 6:00 PM PST",
  targetDate: "2026-09-15T18:00:00-07:00",
  eyebrow: "FREE 45-MINUTE LIVE BRIEFING FOR VETERANS & ACTIVE DUTY — CALIFORNIA",
  phone: "(818) 231-0061",
  email: "oscar@greatwesternfunding.com",
  nmls: "NMLS# 667612",
  companyNmls: "Company NMLS# 2739318",
  website: "www.greatwesternfunding.com",
  company: "Great Western Funding",
  address: "2906 Hermosa Ave, La Crescenta, CA 91214",
  host: "Oscar Tobar",
};

export const ASSETS = {
  logo: "https://customer-assets-lqy194kg.emergentagent.net/job_funding-webinar/artifacts/94m11zb2_image.png",
  house: "https://webinar.greatwesternfunding.com/assets/house.jpg",
  oscar: "https://webinar.greatwesternfunding.com/assets/oscar.jpg",
  blueprint: "https://webinar.greatwesternfunding.com/assets/blueprint.jpg",
};

export const HERO = {
  headline1: "Know Your Exact VA",
  headline2: "Purchasing Power—",
  headline3: "Before You Talk to a Single Lender",
  sub: "The free 45-minute live session that shows veterans and active duty service members their exact $0-down purchasing power — before getting quoted like a conventional buyer or shopped around to four lenders at once.",
  quote: 'What if the down payment you\'ve been told you "need" isn\'t actually required by your VA benefit at all?',
  countdownLabel: "The Live Briefing Starts In:",
  cta: "Reserve My Free Seat",
  notice: "Low Ticket Notice! — Seats fill fast",
};

export const FORM_BENEFITS = [
  "Free Live Webinar Access",
  "Live VA Entitlement & Purchasing Power Calculation",
  "Document & Timeline Checklist",
  "Credit Guidance Before Any Hard Pull",
  "Direct Follow-Up With Oscar — No Call Center Hand-Offs",
];

export const SMS_CONSENT =
  "By checking this box, I consent to receive SMS messages from Great Western Funding regarding my inquiry, appointments, mortgage application, educational events, service updates, follow-up communications, and promotional offers. Message frequency may vary. Message and data rates may apply. Reply STOP to opt out or HELP for assistance. Consent is not a condition of purchasing any property, product, or service.";

export const MARQUEE_ITEMS = [
  "45 MINUTES",
  "5 CORE MODULES",
  "LIVE Q&A INCLUDED",
  "CALIFORNIA COVERAGE",
  "NO COST TO ATTEND",
  "VA HOME LOAN & $0-DOWN SPECIALISTS",
];

export const PROBLEM = {
  label: "[001] — The Problem",
  headline: "VA Home Loans Should Not Feel Like Decoding Fine Print.",
  body: "You earned this benefit through service — yet most veterans and active duty buyers are handed conventional-loan math, vague answers about entitlement, and four competing quotes that never explain what the VA guarantee actually does. This 45-minute briefing strips out the jargon and shows you, step by step, how your $0-down purchasing power is really calculated — so the fine print stops being fine print.",
};

export const LETTER = {
  label: "[002] — A Letter From The Host",
  salutation: "Fellow Veteran,",
  intro: "If you've started looking into buying a home, you've probably already run into some version of these three ideas:",
  myths: [
    '"You need a down payment saved up before you can even start looking."',
    '"Every lender treats VA loans the same, so it doesn\'t matter who you call first."',
    '"You should wait until your finances are \'more stable\' before finding out what you qualify for."',
  ],
  paragraphs: [
    'Here\'s what years of working inside the VA loan process have taught me: none of those beliefs hold up. The VA guarantee was built specifically so eligible veterans and service members can purchase with $0 down — the "required down payment" you\'ve been told about often isn\'t a VA requirement at all.',
    "And lenders are not interchangeable. A lender who works with VA files every day reads entitlement, funding fee exemptions, and residual income very differently from one who mostly closes conventional loans — and that difference shows up in what you're quoted and how smoothly things move.",
    'As for waiting until things feel "more stable" — understanding your position costs nothing and requires no hard credit pull. Knowing your number early is what creates stability, because you can plan around facts instead of guesses. That\'s exactly what this briefing is designed to give you.',
  ],
  signature: "— Oscar Tobar, Great Western Funding",
};

export const AUDIENCE = {
  label: "[003] — Who This Is For",
  headline: "This Training Is Designed For:",
  items: [
    { icon: "Medal", text: "Veterans Exploring Homeownership Options" },
    { icon: "Shield", text: "Active Duty Service Members Preparing to Buy" },
    { icon: "Home", text: "Guard & Reserve Members Who Qualify for VA Benefits" },
    { icon: "Heart", text: "Surviving Spouses with VA Loan Eligibility" },
    { icon: "HelpCircle", text: "Anyone Who's Been Told They Need a Down Payment First" },
  ],
};

export const STEPS = [
  { num: "01", title: "Reserve", body: "Lock in your free seat. Takes 30 seconds — no documents, no credit pull." },
  { num: "02", title: "Watch", body: "Join the live 45-minute briefing. Bring your questions for the live Q&A." },
  { num: "03", title: "Prepare", body: "Use the document & timeline checklist to get organized on your schedule." },
  { num: "04", title: "Decide", body: "Know your number, know your options — and decide your next move on your terms." },
];

export const CURRICULUM = {
  label: "[004] — The Curriculum",
  headline: "Get a Sneak Peek Into the Webinar",
  sub: "5 Modules · 45 Minutes Total",
  modules: [
    { num: "01", title: "Understand Your Benefit", body: "What VA entitlement actually covers and how $0-down purchasing power is calculated." },
    { num: "02", title: "Know What to Prepare", body: "Documents and planning questions for the process — before any hard credit pull." },
    { num: "03", title: "Explore VA Loan Considerations", body: "Eligibility, entitlement, funding fee, appraisal, and how VA guidelines differ from conventional." },
    { num: "04", title: "Avoid Common Missteps", body: "Why rate-shopping across multiple lenders costs veterans money and time." },
    { num: "05", title: "Leave With Next Steps", body: "Your personal purchasing power number + a clear next step, no obligation." },
  ],
};

export const HOST = {
  label: "[005] — Your Host",
  headline1: "Guidance From Someone Who Works ",
  headlineAccent: "Inside",
  headline2: " the Process.",
  paragraphs: [
    "I'm Oscar Tobar, and I've spent my career at Great Western Funding working directly with veterans, active duty service members, and their families across California and Florida. Day in and day out, I sit inside the VA loan process — entitlement calculations, certificates of eligibility, funding fee exemptions, appraisals — the machinery most buyers never get to see.",
    "What I've learned is simple: veterans don't struggle with VA loans because the benefit is complicated. They struggle because nobody takes 45 minutes to explain it before the quotes start flying. Most are treated like conventional buyers from the first phone call, told to bring a down payment their benefit may not require, and shopped to multiple lenders before anyone explains what their entitlement actually covers.",
    "This webinar exists to fix that sequence. You learn how your purchasing power is calculated first — in plain English, with no application, no hard credit pull, and no obligation — so that every conversation you have afterward happens on your terms.",
  ],
  facts: [
    { k: "COMPANY", v: "Great Western Funding" },
    { k: "NMLS#", v: "NMLS# 667612" },
    { k: "COMPANY NMLS#", v: "Company NMLS# 2739318" },
    { k: "LICENSED IN", v: "California & Florida" },
  ],
};

export const FAMILIAR = {
  label: "[006] — Sound Familiar?",
  headline: "If You're Like Most Veterans & Active Duty Buyers I Work With...",
  paragraphs: [
    '...you\'ve probably already hit a wall or two. Maybe a lender quoted you like any other buyer and never mentioned your $0-down benefit. Maybe you were told "not yet" — save more, wait longer, come back when things are more stable — without anyone explaining what actually drives a VA approval.',
    "And the confusion compounds: entitlement, funding fees, residual income, COEs — everyone uses the words, nobody defines them. So you're left comparing four quotes that don't compare, unsure which factors matter for your situation and which are just noise. That fog is not a you-problem. It's an information problem — and it's fixable in 45 minutes.",
  ],
  changesTitle: "Here's What Changes After This Webinar:",
  changes: [
    "You'll know your exact $0-down purchasing power before you talk to a single lender",
    "You'll understand which eligibility factors actually matter — and which ones don't",
    "You'll have a clear next step and a direct line to one broker, not a shared-lead call center",
  ],
};

export const TAKEAWAYS = {
  label: "[007] — The Takeaways",
  headline: "What You'll Walk Away With",
  cards: [
    { icon: "Eye", title: "Clearer View", body: "A plain-English picture of how your VA benefit translates into real purchasing power." },
    { icon: "ClipboardList", title: "Preparation Checklist", body: "The exact documents and timeline steps to have ready — before anyone pulls credit." },
    { icon: "MessageSquare", title: "Questions to Ask", body: "The questions that separate a VA-fluent lender from one who treats you like a conventional buyer." },
    { icon: "ArrowRightCircle", title: "Optional Next Step", body: "A no-obligation path to your personal purchasing power number, if and when you want it." },
  ],
};

export const FAQ = {
  label: "[008] — Before You Ask",
  headline: "Common Questions",
  items: [
    { q: "Is the webinar free?", a: "Yes — completely free. This is a 45-minute educational briefing on VA home loans and $0-down purchasing power. There is no cost to attend, no upsell at the end, and nothing to buy." },
    { q: "Is this a loan application?", a: "No. Attending is not a loan application and does not start one. This is an educational session about how VA entitlement and purchasing power work. Any application would be a separate, deliberate step you'd choose to take later — or not at all." },
    { q: "Will attending affect my credit?", a: "No. There is no hard credit pull required to attend or register. In fact, one of the modules covers credit guidance before any hard pull, so you know exactly where you stand before anyone runs your credit." },
    { q: "Who is this webinar for?", a: "Veterans, active duty service members, Guard & Reserve members, and surviving spouses with VA loan eligibility — especially anyone who has been told they need a down payment first, or has been quoted like a conventional buyer." },
    { q: "What will be covered?", a: "Five modules over 45 minutes: understanding your VA benefit, what to prepare, VA loan considerations (entitlement, funding fee, appraisal), common missteps like rate-shopping across multiple lenders, and your clear next steps — plus live Q&A." },
    { q: "Is it live or on demand?", a: "It's a live session — September 15th, 2026 at 6:00 PM PST — with live Q&A, so you can ask questions about your specific situation. Register even if you're unsure you can attend; registrants receive the follow-up materials." },
    { q: "What happens after I register?", a: "You'll receive a confirmation with the session details, followed by a reminder before we go live. That's it — no sales calls, no call-center hand-offs, and no obligation of any kind." },
    { q: "Do I have to speak with a loan officer?", a: "No. Attending carries zero obligation. If you want a personal VA purchasing power calculation afterward, that option is available directly with Oscar — but it's entirely optional and entirely on your timeline." },
  ],
};

export const FINAL_CALL = {
  label: "[009] — Final Call",
  headline: "Your Next Move Starts With a Clearer Map.",
  bullets: [
    "45-minute live briefing — free, no cost ever",
    "No loan application, no hard credit pull to attend",
    "Live VA entitlement & purchasing power walkthrough",
    "Direct follow-up with Oscar — never a call center",
  ],
};

export const REPLAY = {
  eyebrow: "Replay — Know Your Exact VA Purchasing Power",
  headline: "Missed the live session, or want to watch it again? It's below.",
  videoPlaceholder: "Replay video coming soon",
  videoCaption: "Oscar Tobar walks through your exact $0-down VA purchasing power — 45 minutes.",
  countdownLabel: "This replay comes down in:",
  recapTitle: "In Case You Want the Recap",
  recap: [
    "You'll know your exact $0-down purchasing power before you talk to a single lender",
    "You'll understand which eligibility factors actually matter — and which ones don't",
    "You'll have a clear next step and a direct line to one broker, not a shared-lead call center",
  ],
  ctaTitle: "Ready to Get Your Personal Number?",
  ctaBody: "The replay covers the general picture. Your actual purchasing power depends on your specific entitlement, credit, and timeline — that's a quick one-on-one conversation, not a form. Book a time that works and I'll walk through your numbers personally.",
  ctaButton: "Book My 1-on-1 Purchasing Power Call",
  hostTitle: "Owner & Broker, Great Western Funding",
  hostNote: "Independent VA loan specialist — I personally handle every file, start to finish, no call center hand-offs.",
  faqTitle: "Quick Questions",
  faq: [
    { q: "Do I need to have watched live to book a call?", a: "No — the replay covers everything, and booking works the same either way." },
    { q: "Will booking a call pull my credit?", a: "No — this is a conversation about your numbers first. Nothing gets pulled until you say go." },
    { q: "Is there any cost?", a: "No, this session is completely free, no obligation." },
  ],
};

export const STATES = ["California", "Other"];
export const JOURNEY_OPTIONS = [
  "Just exploring my options",
  "Buying in 0–3 months",
  "Buying in 3–6 months",
  "Buying in 6+ months",
  "PCS / relocating soon",
];

// Tag automatically applied to every lead on form submission
export const LEAD_TAG = "cal-lead";

// GHL Calendar — "Webinar Registration California September 15"
export const GHL_CALENDAR = {
  name: "Webinar Registration California September 15",
  id: "5SiFqiiCJf7kcR7n5gcu",
  embedUrl: "https://api.leadconnectorhq.com/widget/booking/5SiFqiiCJf7kcR7n5gcu",
};

// Mock persistence
export const saveRegistration = (data) => {
  const existing = JSON.parse(localStorage.getItem("gwf_registrations") || "[]");
  existing.push({
    ...data,
    tags: [LEAD_TAG],
    id: Date.now(),
    createdAt: new Date().toISOString(),
  });
  localStorage.setItem("gwf_registrations", JSON.stringify(existing));
  return true;
};
